import React from 'react';
import { ConfigProvider } from 'antd';
import LocaleProvider from 'antd/lib/locale';

import { getAntdLocale } from './antdLocale';

interface AntdProviderProps {
  children: React.ReactNode;
}

/**
 * Wraps both LocaleProvider (old) and ConfigProvider (new) for locale support.
 * LocaleProvider needed for RangePicker, ConfigProvider for DatePicker.
 *
 * Doesn't make much sense, but I guess the version we use was in progress of migration
 */
export const AntdProvider: React.FC<AntdProviderProps> = ({ children }) => {
  const locale = getAntdLocale();

  return (
    <LocaleProvider locale={locale}>
      <ConfigProvider locale={locale}>{children}</ConfigProvider>
    </LocaleProvider>
  );
};
